export const getUrlObject = url => new URL(url)

export const getUrlWithoutParams = ({ href, search }) => href.replace(search, '')

export const isAtDomain = (url, domain) => getUrlObject(url).origin === domain
